import { rem, MenuItem, MenuItemProps, Flex } from '@vimeo/bokeh';

interface IBokehMenuItemProps extends Partial<MenuItemProps> {
  dataId?: string;
}

export function BokehMenuItem({ children, icon, dataId, ...rest }: IBokehMenuItemProps) {
  return (
    <MenuItem
      padding={`${rem(8)} ${rem(16)} ${rem(8)} ${icon ? rem(8) : rem(16)}`}
      {...(icon
        ? {
            icon: (
              <Flex justifyContent="center" alignItems="center">
                {icon}
              </Flex>
            ),
          }
        : {})}
      data-id={dataId}
      fontSize={'text-sm'}
      sx={{
        svg: {
          width: rem(20),
          height: rem(20),
          path: {
            fill: 'text-primary',
          },
        },
      }}
      {...rest}
    >
      {children}
    </MenuItem>
  );
}
